import React from 'react';
import AnimatedSection from './AnimatedSection';

const About = () => {
  return (
    <AnimatedSection id="about" className="section section-dark">
      <div className="container">
        <h2>Om Mig</h2>
        <div className="about-grid">
          <div className="about-content">
            <div className="about-text">
              <p>
                Jag är en ny webbutvecklare med stort intresse för att skapa moderna och användarvänliga webbplatser. Under min utbildning på Karlstads universitet har jag fått en bra grund inom både frontend och backend, och jag fortsätter att lära mig mer varje dag.
                Jag tycker om att skriva kod som är tydlig, enkel att förstå och som ger en bra upplevelse för användaren. Jag trivs med att lösa problem och att se mina idéer växa fram till fungerande webblösningar.
              </p>
            </div>
            <div className="about-stats">
              <div className="stat-item">
                <span className="stat-number">0</span>
                <span className="stat-label">År Erfarenhet</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">3+</span>
                <span className="stat-label">Projekt</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">6+</span>
                <span className="stat-label">Programeringspråk</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">100%</span>
                <span className="stat-label">Engagemang</span>
              </div>
            </div>
          </div>
          <div className="about-info">
            <div className="personal-info">
              <div className="info-item">
                <strong>Ålder</strong>
                <span>25 år</span>
              </div>
              <div className="info-item">
                <strong>Plats</strong>
                <span>Karlstad, Sverige</span>
              </div>
              <div className="info-item">
                <strong>Körkort</strong>
                <span>B med tillgång till bil, Trukkort och Traverskort</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default About;